import { Card, Avatar } from 'antd';
import React from 'react';
import UserProfilePlaceholder from 'assets/img/placeholder/user-profile.svg';
import styled from 'styled-components';

const StyledCard = styled(Card)`
  margin-block: 30px;
  .ant-card-meta {
    align-items: center;
  }
  .ant-card-meta-title {
    text-align: left;
    color: var(--text-text-500, #3a4861);
    /* Body/Body 3 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.06px;
  }
`;
const CardMetaUser = ({ email }) => {
  return (
    <StyledCard>
      <Card.Meta avatar={<Avatar src={UserProfilePlaceholder} />} title={email} />
    </StyledCard>
  );
};

export default CardMetaUser;
